import { useState } from 'react';

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

import useAlertStore from '@/store/alert.store';

export const GlobalAlert = () => {
  const { isOpen, options, closeAlert } = useAlertStore();
  const [loading, setLoading] = useState(false);

  if (!isOpen || !options) return null;

  const { title, description, onConfirm, confirmText, type } = options;

  const classMap = {
    destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
    success: 'bg-green-600 text-white hover:bg-green-700',
    warning: 'bg-yellow-500 text-black hover:bg-yellow-600',
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
      closeAlert();
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={closeAlert}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          {onConfirm && (
            <AlertDialogAction
              disabled={loading}
              onClick={e => {
                e.preventDefault();
                handleConfirm();
              }}
              className={classMap[type]}
            >
              {confirmText || 'Confirm'}
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
